<template>
  <div class="dashboard">
    <BgSidebar :routes="routes" :testRoutes="sidebarRoutes" />
    <div
      :class="`dashboard__content ${
        expanded && 'dashboard__content--expanded'
      } ${fullWidth && 'dashboard__content--full'}`"
      :style="{
        paddingLeft: leftPadding + 'px',
        paddingTop: topPadding + 'px',
      }"
    >
      <transition name="slide-fade">
        <bg-loader :dark="true" v-if="$root.loading"></bg-loader>
        <router-view v-else :key="$route.fullPath"></router-view>
      </transition>
    </div>
  </div>
</template>

<style lang="scss">
.dashboard__content {
  transition: width 0.3s ease-in-out;

  padding-top: 70px;
  width: 1400px;
  @media (max-width: 1400px) {
    width: calc(100% - 45px);
  }
}
.dashboard__content--full {
  width: 100%;
  padding-top: 45px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
  transition-delay: 0.2s;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<script>
import BgSidebar from "@/components/bg-sidebar";
import BgLoader from "@/components/bg-loader";
import API from "@/api";
import { mapState } from "vuex";
import store from "@/store";
import axios from "axios";
export default {
  components: {
    BgSidebar,
    BgLoader,
  },
  name: "dashboard",
  watch: {
    async $route(to) {
      let t = to.path.includes("/test/") || to.path.includes("/create-test/");
      if (
        this.$route.params.id &&
        this.$route.params.id != this.testState.id &&
        t
      ) {
        await store.dispatch("fetchTest", to.params.id);
      }
      this.expanded =
        to.path.includes("/test/") || to.path.includes("video-test");
      this.fullWidth =
        to.path.includes("/recording") ||
        to.path.includes("/heatmaps") ||
        to.path.includes("/journey") ||
        to.path.endsWith("/video") ||
        to.path.includes("/video?") ||
        to.path.includes("/predictions") ||
        to.path.includes("/predictions/heatmaps") ||
        (to.path.includes("/research/test/") &&
          to.path.includes("/participants/"));
      this.getRoutes();
      this.checkInsightsAvailability(this.$route.params.id);
    },
    "$route.params.id": function (newId) {
      if (newId) {
        this.checkInsightsAvailability(newId);
        // this.checkTagsAvailability(newId);
      }
    },
  },
  computed: {
    ...mapState({
      testState: (state) => state.test,
    }),
    leftPadding() {
      if (this.$route.path.includes("predictions/heatmaps/")) {
        return 200;
      } else {
        return 314;
      }
    },
    topPadding() {
      if (this.$route.path.includes("predictions/heatmaps/")) {
        return 0;
      } else {
        return 70;
      }
    },
  },
  methods: {
    async getRoutes() {
      if (location.pathname.includes("video-test")) {
        this.sidebarRoutes = this.videoTestRoutes;
      } else if (location.pathname.includes("/admin/")) {
        this.sidebarRoutes = this.adminRoutes;
      } else if (this.testState.platform === "video") {
        this.sidebarRoutes = this.researchVideoRoutes;
      } else if (location.pathname.includes("/predictions")) {
        this.sidebarRoutes = [];
      } else if (location.pathname.includes("/research/test/")) {
        this.sidebarRoutes = this.researchRoutes;
      } else if (location.pathname.includes("/test/")) {
        this.sidebarRoutes = this.testRoutes;
      } else {
        this.sidebarRoutes = [];
      }

      if (
        this.testState.platform === "desktop" &&
        !this.sidebarRoutes.find((el) => el.path === "heatmaps") &&
        location.pathname.includes("/research/test/")
      ) {
        this.sidebarRoutes.splice(4, 0, {
          name: "Heatmaps",
          path: "heatmaps",
        });
      } else if (
        this.testState.platform === "mobile" &&
        this.sidebarRoutes.find((el) => el.path === "heatmaps") &&
        location.pathname.includes("/research/test/")
      ) {
        this.sidebarRoutes.splice(4, 1);
      }
    },
    waitForToken() {
      return new Promise((resolve) => {
        const check = () => {
          const token = localStorage.getItem("bg-token");
          if (token && token.startsWith("Bearer ")) {
            // optionally apply it to axios again here
            axios.defaults.headers.common["Authorization"] = String(token);
            resolve();
          } else {
            setTimeout(check, 100); // retry every 100ms
          }
        };
        check();
      });
    },
    checkInsightsAvailability(id) {
      if (id) {
        API.test.getInsights(id).then((res) => {
          if (
            res.data.insights.length > 0 &&
            !this.sidebarRoutes.find((el) => el.path === "insights")
          ) {
            this.testRoutes.splice(1, 0, {
              name: "Insights",
              path: "insights",
            });
          } else if (
            !location.pathname.includes("research") &&
            res.data.insights.length === 0 &&
            this.sidebarRoutes.find((el) => el.path === "insights")
          ) {
            const index = this.sidebarRoutes.findIndex(
              (el) => el.path === "insights"
            );
            this.sidebarRoutes.splice(index, 1);
          }
        });
      }
    },
    async checkTagsAvailability(id) {
      // check what this method does
    },
  },
  async mounted() {
    await this.waitForToken();
    this.getRoutes();
    if (!this.$route.path.includes("admin")) {
      this.checkInsightsAvailability(this.$route.params.id);
      // this.checkTagsAvailability(this.$route.params.id);
    }
    this.$store.dispatch("fetchAllUsers");
    this.$store.dispatch("fetchAllTests");
    this.$store.dispatch("fetchCompany");
    if (this.$store.state.user.user.company.licence_analysis) {
      await this.$store.dispatch("fetchAllCompanies");
    }
  },
  data() {
    return {
      isHeatmap: true,
      fullWidth:
        location.pathname.includes("/recording") ||
        location.pathname.includes("/heatmaps") ||
        location.pathname.includes("/journey") ||
        location.pathname.endsWith("/video") ||
        location.pathname.includes("/video?") ||
        location.pathname.includes("/predictions") ||
        location.pathname.includes("/predictions/heatmaps") ||
        (location.pathname.includes("/research/test/") &&
          location.pathname.includes("/participants/")),
      expanded:
        location.pathname.includes("/test/") ||
        location.pathname.includes("/admin/") ||
        location.pathname.includes("/predictions") ||
        location.pathname.includes("/video-test/"),
      videoTestRoutes: [
        {
          name: "Summary",
          path: "summary",
        },
        {
          name: "Scenes",
          path: "scenes",
        },
        {
          name: "Moments",
          path: "moments",
        },
        {
          name: "Dynamic analysis",
          path: "dynamic-analysis",
        },
        {
          name: "Qualitative feedback",
          path: "qualitative-feedback",
        },
        {
          name: "Participants",
          path: "participant",
        },
      ],
      testRoutes: [
        {
          name: "Overview",
          path: "overview",
          icon: "overview",
        },
        {
          name: "Suggestions",
          path: "suggestions",
          icon: "pageInsights",
        },
        {
          name: "Recordings",
          icon: "videos",
          dropdown: true,
        },
        {
          name: "Tags",
          path: "tags",
          icon: "tags",
        },
        {
          name: "Pages",
          path: "page-insights",
          icon: "pageInsights",
        },
      ],
      researchRoutes: [
        {
          name: "Test setup",
          path: "test-setup",
        },
        {
          name: "Participants",
          path: "participants",
          icon: "overview",
        },
        {
          name: "Tags",
          path: "tags",
        },
        {
          name: "Pages",
          path: "pages",
        },

        {
          name: "Insights",
          path: "insights",
        },
      ],
      researchVideoRoutes: [
        {
          name: "Test setup",
          path: "test-setup",
        },
        {
          name: "Participants",
          path: "participants",
          icon: "overview",
        },
        {
          name: "Scenes",
          path: "scenes",
        },
        {
          name: "Qualitative feedback",
          path: "qualitative-feedback",
        },
        {
          name: "Dynamic Analysis",
          path: "dynamic-analysis",
        },
        {
          name: "Moments",
          path: "moments",
        },
        {
          name: "Insights",
          path: "insights",
        },
      ],
      predictionRoutes: [
        // {
        //   name: "Dashboard",
        //   path: "/predictions/dashboard",
        // },
        // {
        //   name: "Projects",
        //   path: "/predictions/projects",
        // },
        {
          name: "Heatmaps",
          path: "/predictions/heatmaps",
        },
      ],
      adminRoutes: [
        {
          name: "Companies",
          path: "/admin/companies",
          icon: "overview",
        },
        {
          name: "Users",
          path: "/admin/users",
          icon: "overview",
        },
      ],
      sidebarRoutes: [],
      routes: [
        {
          name: "Home",
          path: "home",
          icon: "home",
        },
        {
          name: "User tests",
          path: "tests",
          icon: "allTests",
        },
        {
          name: "Research",
          path: "research",
          icon: "research",
          noLicenceDisabled: true,
        },
        // {
        //   name: "Predictions",
        //   path: "predictions",
        //   icon: "eye",
        // },
        {
          name: "Resources",
          path: "resources",
          icon: "book",
        },
        {
          name: "Organisation",
          path: "organisation",
          icon: "department",
        },
        {
          name: "Members",
          path: "members",
          icon: "members",
          demoDisabled: true,
        },
        {
          name: "Account",
          path: "account",
          icon: "account",
        },
        {
          name: "Admin",
          path: "admin/companies",
          icon: "settings",
          noLicenceDisabled: true,
        },
      ],
    };
  },
};
</script>
